import SectionHeading from "./SectionHeading";
import { milestones } from "@/mocks/chiGuaData";

const badgeStyle: Record<string, string> = {
  立人设: "bg-secondary-500 text-background-50",
  埋线: "bg-secondary-200 text-secondary-900",
  崩: "bg-primary-500 text-background-50",
  锤: "bg-accent-500 text-foreground-950",
  反转: "bg-primary-300 text-primary-950",
  回锅: "bg-primary-300 text-primary-950",
};

export default function TimelineSection() {
  return (
    <section id="scene" className="relative overflow-hidden bg-foreground-950 py-14 text-background-50 md:py-20">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-60"
        style={{
          backgroundImage:
            "radial-gradient(circle at 90% 10%, oklch(var(--primary-500)/0.35), transparent 32%), radial-gradient(circle at 10% 90%, oklch(var(--accent-500)/0.2), transparent 30%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          light
          index="03"
          en="The Scenes"
          title="一场塌房的完整名场面"
          desc="从高光期立人设，到台下物料流出、关键节点崩盘、实锤回旋，再到公关与反转——一栋「楼」是怎么一层层塌下来的。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-5">
          {milestones.map((m, i) => (
            <article
              key={m.dateLabel}
              className="relative flex flex-col rounded-2xl border border-background-50/10 bg-background-50/[0.04] p-5"
            >
              <div className="flex items-center justify-between">
                <span className="section-index font-heading text-3xl font-black text-background-50/20">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span
                  className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold ${
                    badgeStyle[m.badge] || "bg-secondary-500 text-background-50"
                  }`}
                >
                  {m.badge}
                </span>
              </div>
              <p className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
                {m.dateLabel}
              </p>
              <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-background-50">
                {m.head}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200/80">{m.body}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 rounded-2xl bg-accent-500/15 px-5 py-5 ring-1 ring-inset ring-accent-400/30 md:flex-row md:items-center md:px-6">
          <p className="flex items-center gap-2 text-sm font-medium text-background-100">
            <i className="ri-eraser-line text-accent-400" />
            不是每个人设崩塌都会走到最后一步——有的在「埋线」就被及时止损，有的则被公关「回锅」。阶段不必完整走完。
          </p>
          <a
            href="#about"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-950 transition-colors hover:bg-white"
          >
            围观我们怎么整理
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}